
<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container py-8 p-2">

                    <div class="modal-logo">
                        <slot name="logo">

                        </slot>
                    </div>

                    <div class="modal-content" >

                        <div class="modal-header">
                            <h3>
                                <slot name="header">

                                </slot>
                            </h3>
                        </div>

                        <div class="modal-body">
                            <slot name="body">
                          
                            </slot>
                        </div>
                    </div>

                    <!--<div class="modal-footer">
                        <slot name="footer">
                            <button class="btn btn--slate-blue btn--continue" @click="$emit('close')">
                                Done
                            </button>
                        </slot>
                    </div>-->
                </div>
            </div>
        </div>
    </transition>
</template>




<script>

    export default {
        name: 'AccountModal',
        props: {
            roomIndex: Number,
            isFull: Boolean
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

    /* width */
        .modal-wrapper ::-webkit-scrollbar {
            width: 10px;
        }

    /* Track */
        .modal-wrapper ::-webkit-scrollbar-track {
            background: rgb(234, 229, 227);
        }

    /* Handle */
        .modal-wrapper ::-webkit-scrollbar-thumb {
            background: rgb(66, 82, 96);
        }

        /* Handle on hover */
            .modal-wrapper ::-webkit-scrollbar-thumb:hover {
                background: #555;
            }


       .modal-container {
           width: 90%;
           height: 80vh;
           max-width: 1400px;
           margin: 0px auto;
       
           background-color: #eae5e3;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
           position: relative;
           display: flex;
           flex-direction: column;
           justify-content: flex-end;

       }

    .modal-content {
        flex-grow: 1;
        text-align: center;
        overflow-y: scroll;
        overflow-x: hidden;
        max-width: 800px;
        width: 100%;
        padding-left: 25px;
        padding-right: 25px;
        margin: 0 auto;
    }

        .modal-content.full {
        max-width: 100%;
        }
        .modal-logo {
           background-color: #eae5e3;
           border-radius: 50%;
           width: 80px;
           height: 80px;
           position: absolute;
           left: 50%;
           top: -40px;
           transform: translateX(-50%);
       }

        .modal-logo img {
            display: block;
            margin: 0 auto;
            height: 44px;
            top: 50%;

            transform: translateY(-50%);
            position: relative;
        }

       .modal-header h3 {
           margin-top: 0;
           font-size: 36px;
       }

    .modal-body {
        margin: 20px 0;

    }

       .modal-default-button {
           float: right;
       }

    .modal-footer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-left: 25px;
        padding-right: 25px;
    }

       /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(1.1);
               transform: scale(1.1);
           }


           .modal-full .modal-content{
               max-width: 100%;
           }
</style>